import { graphql } from '~/__gql__';

export const mutationRequestAVAToolMoreInfo = graphql(/* GraphQL */ `
  mutation RequestAVAToolMoreInfo {
    requestAVAToolMoreInfo
  }
`);
